import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Root from './routes/Root';
import ErrorPage from './routes/Error';
import Home from './routes/Home';
import About from './routes/About';
import Facilities from './routes/Facilities';
import LessonsAndBoarding from './routes/LessonsAndBoarding';
import Contact from './routes/Contact';
import HorseShows from './routes/HorseShows';

const router = createBrowserRouter([
	{
		path: '/',
		element: <Root />,
		errorElement: <ErrorPage />,
		children: [
			{
				path: '/',
				element: <Home />,
			},
			{
				path: '/about',
				element: <About />,
			},
			{
				path: '/facilities',
				element: <Facilities />,
			},
			{
				path: '/boarding',
				element: <LessonsAndBoarding />,
			},
			{
				path: '/contact',
				element: <Contact />,
			},
			{
				path: '/horse-shows',
				element: <HorseShows />,
			},
		],
	},
]);

function App() {
	return (
		<>
			<RouterProvider router={router} />
		</>
	);
}

export default App;
